import { render } from "./EditPvsSystem.vue?vue&type=template&id=c54222d0&ts=true"
import script from "./EditPvsSystem.vue?vue&type=script&lang=ts"
export * from "./EditPvsSystem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__